export default {
  root: {},
  tableCellNoEdit: { paddingLeft: 0, paddingRight: 0 },
  tableCellEdit: { paddingLeft: 15, paddingRight: 15 },
};
